import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/insufficient-resources.html";

import LanguageManager from "Sources/services/language-manager";

require("Styles/components/popup/insufficient-resources.scss");

class InsufficientResourcesView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);
    }
}

module.exports = InsufficientResourcesView;


// WEBPACK FOOTER //
// ./app/js/components/popup/insufficient-resources.js